module.exports = __webpack_public_path__ + "static/media/psychometrics.724a9047.svg";